import "./index.css"
export default function Header () {
    return <div className="motivate-me-header"></div>
}